import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, withLatestFrom } from 'rxjs/operators';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { appsActions } from '../actions';
import { IState } from '../states';

@Injectable()
export class DashboardAppsEffects {
  constructor(
    private _actions$: Actions,
    private _dashboardStore: Store<IState>,
    private _dashboardService: DashboardService,
  ) {}

  setAppsSettings$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(appsActions.setIsSlackWebhookActive, appsActions.setIsCheckoutAppActive),
        withLatestFrom(this._dashboardStore),
        switchMap(([action, store]) =>
          this._dashboardService.updateDashboardSettings(action.shopId, {
            apps: {
              isCheckoutAppActive: store.dashboard.apps.isCheckoutAppActive,
              isSlackWebhookActive: store.dashboard.apps.isSlackWebhookActive,
            },
          }),
        ),
      ),
    {
      dispatch: false,
    },
  );
}
